import { Failure } from "src/app/core/utils/failure";
import { MinuteEntity } from "../entities/minute.entity";
import { MinutePdf } from "../entities/minutePdf.entity";

export abstract class MinuteRepositoryBase {
    abstract createMinute(audience: MinutePdf): Promise<string | Failure>;
    abstract getMinutesByClaimId(id: string): Promise<MinuteEntity[] | Failure>;
    abstract deleteActa(id: string): Promise<string | Failure>;
}